import { render, staticRenderFns } from "./WorkspaceLearnCompanionOverlay.vue?vue&type=template&id=0dc105f4&scoped=true"
import script from "./WorkspaceLearnCompanionOverlay.vue?vue&type=script&lang=js"
export * from "./WorkspaceLearnCompanionOverlay.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLearnCompanionOverlay.vue?vue&type=style&index=0&id=0dc105f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc105f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc105f4')) {
      api.createRecord('0dc105f4', component.options)
    } else {
      api.reload('0dc105f4', component.options)
    }
    module.hot.accept("./WorkspaceLearnCompanionOverlay.vue?vue&type=template&id=0dc105f4&scoped=true", function () {
      api.rerender('0dc105f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceLearnCompanionOverlay.vue"
export default component.exports